/* Park Pharmacy: cartoon weather card beside the product advisor.
   Forecast and warnings: Met Éireann open data, via the booking helper.
   UV: estimated by the helper from the sun's height and Met Éireann's cloud forecast (free).
   Air quality and pollen (and a measured UV forecast): Open-Meteo (Copernicus CAMS data), only if its paid key is set in the helper.
   Markup and styles: snippets/park-weather-card.liquid */
(function () {
  var holder = document.querySelector('[data-park-weather]');
  if (!holder || !holder.dataset.endpoint) return;
  var scope = holder.closest('.pp-af') || document;
  var urls = {
    sun: holder.dataset.urlSun, cold: holder.dataset.urlCold, hayfever: holder.dataset.urlHayfever,
    skin: holder.dataset.urlSkin, vitamins: holder.dataset.urlVitamins
  };
  var KEY = 'park-weather-v2';

  // Colour for each reading level (good → bad)
  var LEVEL_COLOUR = {
    'good': '#4caf50', 'fair': '#9ccc65', 'low': '#4caf50', 'moderate': '#ffb300',
    'poor': '#ff7a1a', 'high': '#ff7a1a', 'very poor': '#e53935', 'very high': '#e53935',
    'extremely poor': '#8e24aa', 'extreme': '#8e24aa'
  };

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function load() {
    try {
      var c = JSON.parse(sessionStorage.getItem(KEY) || 'null');
      if (c && c.d && Date.now() - c.t < 30 * 60 * 1000) return Promise.resolve(c.d);
    } catch (e) {}
    return fetch(holder.dataset.endpoint, { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (d && d.ok) { try { sessionStorage.setItem(KEY, JSON.stringify({ t: Date.now(), d: d })); } catch (e) {} }
        return d;
      });
  }

  function lv(x) { return String((x && x.level) || '').toLowerCase(); }
  function isHigh(x) { var l = lv(x); return l === 'high' || l === 'very high' || l === 'extreme'; }

  function copyFor(d) {
    var summer = d.month >= 4 && d.month <= 9;
    var air = d.air || {};
    var chips = [];
    var add = function (t, c) { if (chips.length < 2) chips.push({ t: t, c: c }); };
    var out;
    if (d.look === 'hot') {
      out = { tip: 'Warm and sunny. SPF 30 or higher, shade around midday and plenty of water, especially for kids.', cta: 'Shop SPF', url: urls.sun };
      add('Sun cream weather', '#e8384f'); add('Drink plenty', '#3c8de0');
    } else if (d.look === 'sun') {
      out = summer
        ? { tip: 'Lovely out! The sun can burn even on mild days, so pop on SPF if you are out for a while.', cta: 'Shop suncare', url: urls.sun }
        : { tip: 'Bright and dry, great for a walk. Cold air dries out skin, so keep a lip balm handy.', cta: 'Winter skin', url: urls.skin };
      if (summer) add('SPF weather', '#ff9f1c');
    } else if (d.look === 'rain') {
      out = summer
        ? { tip: 'Grab a brolly. Showers wash pollen out of the air, so hay fever is often calmer after rain.', cta: 'Hay fever', url: urls.hayfever }
        : { tip: 'Grab a brolly. It is cold and flu season, so keep tissues and a thermometer handy.', cta: 'Cold & flu', url: urls.cold };
      add('Brolly needed', '#3c8de0');
      if (!summer) add('Cold & flu season', '#ff5a5f');
    } else if (d.look === 'snow') {
      out = { tip: 'Wrap up warm. Cold air dries out skin and lips, so moisturise and keep a lip balm in your pocket.', cta: 'Winter skin', url: urls.skin };
      if (d.low <= 1) add('Icy paths', '#3c8de0');
      add('Wrap up warm', '#8a6de0');
    } else {
      out = summer
        ? { tip: 'Mild and grey. You can still burn through cloud, so SPF if you are out all day.', cta: 'Shop suncare', url: urls.sun }
        : { tip: 'Grey skies. Many people take vitamin D from Halloween to St Patrick’s Day, when there is little sun.', cta: 'Vitamins', url: urls.vitamins };
      if (!summer) add('Cold & flu season', '#ff5a5f');
    }

    // Air quality, UV and pollen can override the tip when they matter most.
    if (isHigh(air.pollen) && d.look !== 'rain') {
      out = { tip: 'High pollen' + (air.pollen.type ? ' (' + air.pollen.type + ')' : '') + ' today. Take your hay fever tablet before you head out, and shower and change after being outdoors.', cta: 'Hay fever', url: urls.hayfever };
    } else if (air.uv && air.uv.value >= 6) {
      out = { tip: 'UV is ' + lv(air.uv) + ' today. SPF 30 or higher, a hat and shade around midday, and keep babies out of direct sun.', cta: 'Shop SPF', url: urls.sun };
    } else if (air.aqi && (lv(air.aqi) === 'poor' || lv(air.aqi) === 'very poor' || lv(air.aqi) === 'extremely poor')) {
      out.tip = 'Air quality is ' + lv(air.aqi) + ' today. If you have asthma or a heart or lung condition, take it easy outdoors and keep your inhaler with you.';
    }

    if (d.windy) add('Windy', '#8a6de0');
    if (d.look !== 'rain' && d.look !== 'snow' && (d.rainMm || 0) < 0.5) add('Dry day', '#4caf50');
    out.chips = chips;
    return out;
  }

  // Air, UV and pollen readings (only those the helper sent)
  function readings(air) {
    if (!air) return '';
    var items = [];
    if (air.aqi && air.aqi.level) items.push({ k: 'Air quality', v: air.aqi.level, l: lv(air.aqi), title: 'European Air Quality Index ' + air.aqi.value });
    if (air.uv && air.uv.level) items.push({ k: 'UV', v: air.uv.value + ' ' + air.uv.level, l: lv(air.uv), title: air.uv.estimated ? 'Estimated highest UV index, from the sun\'s height and the cloud forecast' : 'Highest UV index today' });
    if (air.pollen && air.pollen.level) items.push({ k: 'Pollen', v: air.pollen.level + (air.pollen.type && isHigh(air.pollen) ? ' (' + air.pollen.type + ')' : ''), l: lv(air.pollen), title: 'Tree, grass and weed pollen' });
    if (!items.length) return '';
    return '<ul class="pwx__read" aria-label="Air quality, UV and pollen">' + items.map(function (it) {
      return '<li title="' + esc(it.title) + '"><span class="pwx__dot" style="background:' + (LEVEL_COLOUR[it.l] || '#9aa8b6') + '"></span>' +
        '<span class="pwx__read-k">' + esc(it.k) + '</span> <strong>' + esc(it.v) + '</strong></li>';
    }).join('') + '</ul>';
  }

  function build(d) {
    var look = ['sun', 'hot', 'rain', 'snow', 'cloud'].indexOf(d.look) === -1 ? 'cloud' : d.look;
    var art = scope.querySelector('template[data-pwx-art="' + look + '"]') || document.querySelector('template[data-pwx-art="' + look + '"]');
    var c = copyFor(d);
    var el = document.createElement('div');
    el.className = 'pwx pwx--' + look;
    var html = '<div class="pwx__art"></div><div class="pwx__body">' +
      '<div class="pwx__top"><strong class="pwx__temp">' + esc(d.high) + '°</strong>' +
      '<span class="pwx__desc">' + esc(d.desc) + '</span>' +
      '<span class="pwx__where">Cabinteely ' + (d.day === 'tomorrow' ? 'tomorrow' : 'today') + '</span></div>';
    (d.warnings || []).forEach(function (w) {
      var l = String(w.level || '').toLowerCase();
      html += '<a class="pwx__warn' + (l === 'orange' ? ' pwx__warn--orange' : l === 'red' ? ' pwx__warn--red' : '') +
        '" href="https://www.met.ie/warnings" target="_blank" rel="noopener">⚠ ' + esc(w.text) + '</a>';
    });
    html += '<p class="pwx__tip">' + esc(c.tip) + '</p>';
    html += readings(d.air);
    html += '<div class="pwx__row">';
    c.chips.forEach(function (ch) {
      html += '<span class="pwx__chip"><span class="pwx__dot" style="background:' + ch.c + '"></span>' + esc(ch.t) + '</span>';
    });
    if (c.url) {
      html += '<a class="pwx__cta" href="' + esc(c.url) + '">' + esc(c.cta) +
        ' <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg></a>';
    }
    html += '</div><span class="pwx__credit">Forecast: <a href="https://www.met.ie" target="_blank" rel="noopener">Met Éireann</a>';
    if (d.air && d.air.source === 'open-meteo') {
      html += ' · Air' + (d.air.uv && !d.air.uv.estimated ? ', UV' : '') + ' and pollen: <a href="https://open-meteo.com" target="_blank" rel="noopener">Open-Meteo</a> (Copernicus CAMS)';
    }
    if (d.air && d.air.uv && d.air.uv.estimated) {
      html += ' · UV is our estimate from the cloud forecast';
    }
    html += '</span></div>';
    el.innerHTML = html;
    if (art) el.querySelector('.pwx__art').appendChild(art.content.cloneNode(true));
    return el;
  }

  load().then(function (d) {
    if (!d || !d.ok) return;
    holder.appendChild(build(d));
    holder.hidden = false;
  }).catch(function () {});
})();
